import {
  addAdminRole,
  deleteAdminRole,
  getAdminRoles,
  updateAdminRole,
} from "../actions/admin.role.action";
import TableList from "../components/TableList";
import { AdminRole } from "../models/admin.model";
import { Chip, Stack } from "@mui/material";
import { useRef } from "react";
import AdminRoleForm from "./AdminRoleForm";
import { filterOnKeys, titleStr } from "../lib/helper";
import { FilterGroup, FilterType } from "../components/TableFilter";
import { FormRefEvent, HeadCell } from "../models/base.model";

const headCells: readonly HeadCell[] = [
  {
    id: "name",
    label: "Name",
  },
  {
    id: "permissions",
    label: "Permissions",
    render: (value: string[]) => (
      <Stack direction="row" spacing={1}>
        {(value || []).map((v) => (
          <Chip key={v} label={titleStr(v)} color="info" />
        ))}
      </Stack>
    ),
  },
];

const filters: FilterGroup<AdminRole>[] = [
  {
    title: "Filter By Date",
    items: [
      {
        name: "createdAt",
        type: FilterType.date_range,
      },
      {
        name: "updatedAt",
        type: FilterType.date_range,
      },
    ],
  },
];

export default function AdminRoles() {
  const formRef = useRef<FormRefEvent<AdminRole>>(null);

  const onAddOrUpdate = (param?: AdminRole) => {
    return window.webApp.setTab<AdminRole>({
      title: `${param ? "Update" : "New"} Admin Role`,
      element: <AdminRoleForm ref={formRef} defaultValues={param} />,
      onOk: async () => {
        if (!formRef.current) {
          throw new Error("Form creation error, please refresh or contact us!");
        }
        const value = await formRef.current.onSubmit();
        const res = param
          ? await updateAdminRole({ ...param, ...value })
          : await addAdminRole(value);
        return res;
      },
      show: true,
    });
  };

  const onDelete = (param: AdminRole) => {
    return deleteAdminRole(param.name);
  };

  const onSearch = async (value: string, original: AdminRole[]) => {
    if (original) {
      return { data: original.filter((a) => filterOnKeys(a, ["name"], value)) };
    } else {
      return { data: [] };
    }
  };

  return (
    <TableList<AdminRole>
      headCells={headCells}
      onAddBtnText="New Admin Role"
      uid="name"
      onAdd={onAddOrUpdate}
      onSearch={onSearch}
      searchText="Search by name"
      onEdit={onAddOrUpdate}
      onDelete={onDelete}
      onLoad={getAdminRoles}
      filters={filters}
    />
  );
}
